import React from "react";
import "./style.css";
import {QuestionnaireMultiple} from "../../../../components/QuestionnaireMultiple";

export const CraveFood = (props) => {
  const list = {
    title: "What food do you crave most often?",
    list: [
      { value: 'Sweet treats' },
      { value: 'Salty snacks' },
      { value: 'Fast food' },
      { value: 'Soda' },
      { value: 'None of the above', isNone: true }
    ]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireMultiple {...props} list={list}/>
    </div>
  );
};
